import PublishImg from '@assets/images/video-tutorial/publish.png'
import { VideoTutorial } from '@components/VideoTutorial'
import { useVideoTutorial } from '@components/VideoTutorial/useVideoTutorial'
import type React from 'react'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import css from './styles.module.css'

export const PublishTutorial: React.FC = () => {
  const { publishId, handleViewedTutorial } = useVideoTutorial()

  if (!publishId) {
    return null
  }

  const handleLinkClick = () => {
    handleViewedTutorial(publishId)
    sendGtmEvent(GtmTriggerName.PUBLISH_INTRO)
  }

  const handleCloseClick = () => {
    handleViewedTutorial(publishId)
  }

  return (
    <div className={css.video_tutorial_wrap}>
      <VideoTutorial
        title="Welcome to Publish"
        description="Explore how to create, store, and manage your content"
        img={PublishImg}
        link="https://youtu.be/6otRDWF4iGI?si=PrG5d9D0ZNwLsYMr"
        onLinkClick={handleLinkClick}
        onCloseClick={handleCloseClick}
      />
    </div>
  )
}
